(function () {
  'use strict';

  if (window._kzCartUpsellFallbackLoaded) return;
  window._kzCartUpsellFallbackLoaded = true;

  function isEnglishStore() {
    return window.location.hostname === 'kombatzone.shop';
  }

  function recommendationBaseUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/recommendations/products';
  }

  function setCopy(container) {
    var title = container.querySelector('.kz-also-title');
    var subtitle = container.querySelector('.kz-also-subtitle');

    if (title) {
      title.innerHTML = isEnglishStore()
        ? 'Complete your <span>setup</span>'
        : 'Completa il tuo <span>setup</span>';
    }

    if (subtitle) {
      subtitle.textContent = isEnglishStore()
        ? 'You may also need:'
        : 'Potrebbe servirti anche:';
    }
  }

  function hasCards(container) {
    var grid = container && container.querySelector('[data-upsell-grid]');
    return !!(grid && grid.querySelector('.kz-card'));
  }

  function loadRelatedFallback(container) {
    if (!container || hasCards(container) || container.dataset.kzRelatedFallbackLoading === '1') return;

    var seedId = container.dataset.seedId;
    if (!seedId) return;

    container.dataset.kzRelatedFallbackLoading = '1';

    var limit = container.dataset.limit || 4;
    var grid = container.querySelector('[data-upsell-grid]');
    if (!grid) {
      delete container.dataset.kzRelatedFallbackLoading;
      return;
    }

    var url = recommendationBaseUrl()
      + '?section_id=cart-upsell-recommendations'
      + '&product_id=' + encodeURIComponent(seedId)
      + '&limit=' + encodeURIComponent(limit)
      + '&intent=related';

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendation request failed');
        return response.text();
      })
      .then(function (html) {
        if (hasCards(container)) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.kz-card');

        if (!cards.length) return;

        grid.innerHTML = '';
        cards.forEach(function (card) {
          grid.appendChild(card);
        });
        setCopy(container);
        container.style.display = '';
      })
      .catch(function (error) {
        console.error('Kombat Zone cart recommendation fallback:', error);
      })
      .finally(function () {
        delete container.dataset.kzRelatedFallbackLoading;
      });
  }

  function ensureRecommendations() {
    var container = document.querySelector('[data-upsell-root]');
    if (!container) return;

    setCopy(container);
    if (hasCards(container)) return;

    /* Give the preferred complementary request in main-cart time to finish.
       If it returns no manually configured products, fall back to Shopify's
       auto-generated related recommendations. */
    window.setTimeout(function () {
      if (!hasCards(container)) loadRelatedFallback(container);
    }, 700);
  }

  function scheduleEnsure() {
    window.setTimeout(ensureRecommendations, 0);
    window.setTimeout(ensureRecommendations, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEnsure, { once: true });
  } else {
    scheduleEnsure();
  }

  document.addEventListener('cart:updated', scheduleEnsure);
})();
